import { Component, inject, OnInit } from "@angular/core";
import { NxCell } from "qlik";
import { Title } from "@angular/platform-browser";
import { FilterComponent } from "../../felles/components/filter/filter.component";
import { KpitabellComponent } from "../../felles/components/kpitabell/kpitabell.component";
import { KommunefilterComponent } from "../../felles/components/kommunefilter/kommunefilter.component";
import { QlikService } from "../../felles/services/qlik.service";
import { AccordionComponent } from "@husbanken/designsystem-angular-core";
import { AccordionElementComponent, HjelpetekstComponent } from "@husbanken/designsystem-angular-core";
import { GrafComponent } from "../../felles/components/graf/graf.component";

@Component({
  selector: "stat-energitilskudd",
  templateUrl: "./energitilskudd.component.html",
  imports: [FilterComponent, KpitabellComponent, KommunefilterComponent, AccordionComponent, AccordionElementComponent, HjelpetekstComponent, GrafComponent],
})
export class EnergitilskuddComponent implements OnInit {
  objectKeys = Object.keys;
  statistikkType = "Søknad";
  graferValgt = "utleieboliger";
  valgtFilter: { [key: string]: NxCell[] } = null;
  grafIderForUtleieboliger: string[] = [];
  grafIderForOmsorgsykehj: string[] = [];
  grafIderForEnergiBesparelseOmsorgboliger: string[] = [];
  grafIderForEnergiBesparelseUteleieboliger: string[] = [];
  grafIderForEnergiBesparelseBelop: string[] = [];
  kpiListe: string[] = [];

  typeTekst = {
    Søknad: {
      utleieboliger: [
        "Antall utleieboliger",
        "Viser samlet antall kommunalt eide utleieboliger som omfattes av tiltakene det er sendt inn søknad for, har fått tilsagn på eller fått utbetalt i perioden som er valgt. ",
      ],
      omsorgsykehj: [
        "Antall omsorgsboliger/sykehjemsplasser",
        "Viser samlet antall omsorgsboliger og sykehjemsplasser som omfattes av tiltakene som det er sendt inn søknad for, har fått tilsagn eller blitt utbetalt i perioden som er valgt.",
      ],
      energibesparelseutleieboliger: [
        "Estimert energibesparelse - utleieboliger",
        "Basert på opplysninger om eiendommen, hvilke tiltak og omfanget av dem, samt antall boliger tiltakene omfatter, blir forventet energibesparelse beregnet og angitt i kWt.",
      ],
      energibesparelseomsorgboliger: [
        "Estimert energibesparelse - omsorgsboliger/sykehjemsplasser",
        "Basert på opplysninger om eiendommen, hvilke tiltak og omfanget av dem, samt antall boliger/plasser tiltakene omfatter, blir forventet energibesparelse beregnet og angitt i kWt.",
      ],
      energibesparelsebelop: [
        "Beløp",
        "Viser beløp for innkomne søknader, gitte tilsagn og prosjekter som er utbetalt. Beløpene viser samlet beløp for utleieboliger, omsorgsboliger og sykehjemsplasser.",
      ],
    },
    Tilsagn: {
      utleieboliger: [
        "Antall utleieboliger",
        "Viser samlet antall kommunalt eide utleieboliger som omfattes av tiltakene det er sendt inn søknad for, har fått tilsagn på eller fått utbetalt i perioden som er valgt.",
      ],
      omsorgsykehj: [
        "Antall omsorgsboliger/sykehjemsplasser",
        "Viser samlet antall omsorgsboliger og sykehjemsplasser som omfattes av tiltakene som det er sendt inn søknad for, har fått tilsagn eller blitt utbetalt i perioden som er valgt.",
      ],
      energibesparelseutleieboliger: [
        "Estimert energibesparelse - utleieboliger",
        "Basert på opplysninger om eiendommen, hvilke tiltak og omfanget av dem, samt antall boliger tiltakene omfatter, blir forventet energibesparelse beregnet og angitt i kWt.",
      ],
      energibesparelseomsorgboliger: [
        "Estimert energibesparelse - omsorgsboliger/sykehjemsplasser",
        "Basert på opplysninger om eiendommen, hvilke tiltak og omfanget av dem, samt antall boliger/plasser tiltakene omfatter, blir forventet energibesparelse beregnet og angitt i kWt.",
      ],
      energibesparelsebelop: [
        "Beløp",
        "Viser beløp for innkomne søknader, gitte tilsagn og prosjekter som er utbetalt. Beløpene viser samlet beløp for utleieboliger, omsorgsboliger og sykehjemsplasser.",
      ],
    },
    Utbetaling: {
      utleieboliger: [
        "Antall utleieboliger",
        "Viser samlet antall kommunalt eide utleieboliger som omfattes av tiltakene det er sendt inn søknad for, har fått tilsagn på eller fått utbetalt i perioden som er valgt.",
      ],
      omsorgsykehj: [
        "Antall omsorgsboliger/sykehjemsplasser",
        "Viser samlet antall omsorgsboliger og sykehjemsplasser som omfattes av tiltakene som det er sendt inn søknad for, har fått tilsagn eller blitt utbetalt i perioden som er valgt.",
      ],
      energibesparelseutleieboliger: [
        "Estimert energibesparelse - utleieboliger",
        "Basert på opplysninger om eiendommen, hvilke tiltak og omfanget av dem, samt antall boliger tiltakene omfatter, blir forventet energibesparelse beregnet og angitt i kWt.",
      ],
      energibesparelseomsorgboliger: [
        "Estimert energibesparelse - omsorgsboliger/sykehjemsplasser",
        "Basert på opplysninger om eiendommen, hvilke tiltak og omfanget av dem, samt antall boliger/plasser tiltakene omfatter, blir forventet energibesparelse beregnet og angitt i kWt.",
      ],
      energibesparelsebelop: [
        "Beløp",
        "Viser beløp for innkomne søknader, gitte tilsagn og prosjekter som er utbetalt. Beløpene viser samlet beløp for utleieboliger, omsorgsboliger og sykehjemsplasser.",
      ],
    },
  };

  qlikService = inject(QlikService);
  titleService = inject(Title);

  constructor() {
    this.qlikService.resetFilter();
    this.qlikService.setFylkeFilter();
    this.qlikService.setFilter("VirkemiddelKode", "ENE_TILTAK", false, true);
    this.qlikService.setFilter("TypeTilstand", "Søknad", false, true);
  }

  ngOnInit() {
    this.titleService.setTitle("Statistikk - energitilskudd - Husbanken");
    this.grafIderForUtleieboliger = ["ene-ant-utleieboliger-pr-fylke", "ene-ant-utleieboliger"];
    this.grafIderForOmsorgsykehj = ["ene-ant-omsorgsykehj-pr-fylke", "ene-ant-omsorgsykehj"];
    this.grafIderForEnergiBesparelseOmsorgboliger = ["ene-besparelse-kwt-omsorgboliger-pr-fylke", "ene-besparelse-kwt-omsorgboliger"];
    this.grafIderForEnergiBesparelseUteleieboliger = ["ene-besparelse-kwt-utleieboliger-pr-fylke", "ene-besparelse-kwt-utleieboliger"];
    this.grafIderForEnergiBesparelseBelop = ["ene-beløp-pr-fylke", "ene-beløp"];
    this.kpiListe = [
      "ENE Antall utleieboliger",
      "ENE Antall omsorgsboliger",
      "ENE Antall sykehjemsplasser",
      "ENE Estimert energibesparelse (kwt ) - utleieboliger",
      "ENE Estimert energibesparelse (kwt ) - omsorgsboliger/sykehjemsplasser",
      "ENE EnergiTilskudd Beløp",
    ];
  }

  public filterTilstand(filter) {
    this.qlikService.setFilter("TypeTilstand", filter, false, true);
    this.statistikkType = filter;
  }

  selectedRadio(event) {
    this.graferValgt = event.target.value;
  }

  filterVisning(event) {
    this.valgtFilter = event;
  }

  hentSelectedRadioLabel(): string {
    return this.typeTekst[this.statistikkType][this.graferValgt][0];
  }
}
